import { useEffect, useRef, useState } from "react";
import { subscribe } from "./liveAnnouncer";

// A11Y-10: polite aria-live region for async status updates. Blank-then-set via
// rAF forces SRs to re-read identical messages.
const LiveRegion = () => {
    const [message, setMessage] = useState("");
    const rafIdRef = useRef(0);

    useEffect(() => {
        const unsubscribe = subscribe((next) => {
            setMessage("");
            // Track the rAF id so unmount cleanup can cancel a pending frame.
            rafIdRef.current = requestAnimationFrame(() => {
                rafIdRef.current = 0;
                setMessage(next);
            });
        });
        return () => {
            unsubscribe();
            if (rafIdRef.current) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = 0;
            }
        };
    }, []);

    return (
        <div
            aria-live="polite"
            aria-atomic="true"
            role="status"
            className="visually-hidden"
            data-testid="live-region"
        >
            {message}
        </div>
    );
};

export default LiveRegion;
